import React, {Component} from 'react';
import moment from 'moment';
import Confirm from '../Dialog/Confirm';
import {tryCheckin} from 'actions/CheckinActions';

class CheckinBlock extends Component {
  state={
    checking: false
  }

  tryCheckin = (label, date, sid) => {
    return () => {
    this.activeChecking();
    Confirm(`將簽到${date}-${label}更`)
      .then(
        () => {
          this.props.dispatch(tryCheckin(date, sid, this.dismissChecking));
        },
        () => {
          this.dismissChecking();
        }
      );
    }
  }

  activeChecking = () => {
    this.setState({
      checking: true
    })
  }

  dismissChecking = () => {
    this.setState({
      checking: false
    })
  }

  render() {
    let {label, sessionConfig, record, date, sid} = this.props;
    //prepare session data
    let ableAt = moment(date + " " + sessionConfig.get('ableAt'), "YYYY-MM-DD HH:mm");
    let disableAt = moment(date + " " + sessionConfig.get('disableAt'), "YYYY-MM-DD HH:mm");
    disableAt.isBefore(ableAt) && disableAt.add(1, 'days');
    let checkinAt = record.get('checkinAt');
    let isCheckedin = checkinAt !== null && checkinAt !== undefined;
    let ActionBlock = (
      <button
        className="btn btn-success"
        onClick={this.tryCheckin(label, date, sid)}
        disabled={this.state.checking}
      >
        簽到
      </button>
    );

    let now = moment();
    let isActive = !(now.isAfter(disableAt) || now.isBefore(ableAt));

    if (!isCheckedin) {
      if (now.isAfter(disableAt) || now.isBefore(ableAt)) {
        ActionBlock = (<span />);
      }
    }

    return (
      <div className={"action " + (isActive ? "active" : "")}>
        <div className="lead">
          <div className="shift-label">
            <span className="label label-primary">
              {label}
            </span>
          </div>
          <div className="shift-time">
            {sessionConfig.get('startAt')} - {sessionConfig.get('endAt')}
          </div>
        </div>
        <h1>{record.get('siteName') || '沒有任何編更記錄'}</h1>
        <div>
          {(isCheckedin? <span className="info">{`已於 ${checkinAt} 簽到`}</span> : ActionBlock)}
        </div>
      </div>
    )
  }
}

export default CheckinBlock;



// WEBPACK FOOTER //
// ./src/components/Checkin/CheckinBlock.js